import { render, staticRenderFns } from "./security_rounds_history.vue?vue&type=template&id=22624e7d&scoped=true"
import script from "./security_rounds_history.vue?vue&type=script&lang=js"
export * from "./security_rounds_history.vue?vue&type=script&lang=js"
import style0 from "./security_rounds_history.vue?vue&type=style&index=0&id=22624e7d&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "22624e7d",
  null
  
)

export default component.exports